export var DATE_RANGE_PICKER_CLOSE_PANEL = 'DateRangePicker:panel.close';
export var DATERANGEPICKER_DATE_MASK_ACCEPTED_INPUT = /[a-zA-Z0-9]+/g;
export var DATERANGEPICKER_DATE_MASK_LENGTH = 23;